import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from "react-i18next"
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { RolesList, RolesDisableList } from 'src/components/M_Components/M_Utils/roleConfigList'
import { M_InputTextField, M_Button, LoadingContext, M_StateActions, M_CheckBox, M_Header, BufferService } from 'src/components/M_Components'
import { useDispatch, useSelector } from 'react-redux'
import './pages.css'

export const RoleConfigCrud = ({ handleTabClose }) => {
    const dispatch = useDispatch()
    const M_State = useSelector(state => state.StateKeyValue)
    const passOperation = M_State.filter(obj => obj.key === 'operation')[0]?.value !== null ? M_State.filter(obj => obj.key === 'operation')[0]?.value : 'Error'
    const sessionLine = M_State.filter(obj => obj.key === 'rolesLine')[0]?.value !== null && M_State.filter(obj => obj.key === 'rolesLine')[0]?.value !== undefined ? M_State.filter(obj => obj.key === 'rolesLine')[0]?.value : 'Error'
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [roleName, setRoleName] = useState('')
    const [isExternal, setIsExternal] = useState(false)
    const [permissions, setPermissions] = useState([])
    const [operation, setOperation] = useState(passOperation)
    const [passLine, setPassLine] = useState('')
    const [isFirst, setIsFirst] = useState(true)
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()
    const bufferRoles = new BufferService('viewroledetails')
    const columns = ["List", "Create", "Edit", "Delete", "SelectAll"]
    const sessionKeys = ['operation', 'roleName', 'isExternal', 'permissions', 'passLine', 'isFirst']

    const buildDefaultPermissions = () => JSON.parse(RolesList)

    const mapDetailsToPermissions = (details = []) => {
        let permissionsGrid = buildDefaultPermissions()

        details.forEach((permission) => {
            if (typeof permission !== 'string') {
                return
            }

            columns.forEach((column) => {
                if (!permission.endsWith(column)) {
                    return
                }

                const permissionPrefix = permission.slice(0, -column.length)
                permissionsGrid = permissionsGrid.map((item) => {
                    if (item.Value === permissionPrefix) {
                        return {
                            ...item,
                            [column]: true
                        }
                    }

                    return item
                })
            })
        })

        return permissionsGrid
    }

    const getSelectedDetails = () => {
        const details = []

        permissions.forEach((permissionGroup) => {
            Object.entries(permissionGroup).forEach(([key, value]) => {
                if (key !== 'Name' && key !== 'Value' && value) {
                    details.push(`${permissionGroup.Value}${key}`)
                }
            })
        })

        return details
    }

    const resolveRoleResponse = (response, fallbackLine) => {
        if (Array.isArray(response)) {
            return {
                roleName: fallbackLine?.Name || '',
                isExternal: Boolean(fallbackLine?.IsExternal),
                details: response
            }
        }

        return {
            roleName: response?.RoleName ?? fallbackLine?.Name ?? '',
            isExternal: Boolean(response?.IsExternal ?? fallbackLine?.IsExternal),
            details: Array.isArray(response?.Details) ? response.Details : []
        }
    }

    const isRequestError = (response) => response?.name === 'AxiosError'

    useEffect(() => {
        if (isFirst) {
            dispatch(M_StateActions.removeM_State({ key: 'rolesLine' }))
            dispatch(M_StateActions.removeM_State({ key: 'operation' }))
            setPassLine(sessionLine)
            setIsFirst(false)
        }
        getSessionStorageData(id)
        // eslint-disable-next-line
    }, [])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempO = M_StateData.filter(obj => obj?.key === `operation`)[0]?.value
            const tempRN = M_StateData.filter(obj => obj?.key === `roleName`)[0]?.value
            const tempIE = M_StateData.filter(obj => obj?.key === `isExternal`)[0]?.value
            const tempP = M_StateData.filter(obj => obj?.key === `permissions`)[0]?.value
            const tempL = M_StateData.filter(obj => obj?.key === `passLine`)[0]?.value
            const tempIF = M_StateData.filter(obj => obj?.key === `isFirst`)[0]?.value
            if (tempO || tempRN || tempIE !== undefined || tempP || tempL || tempIF) {
                setOperation(tempO)
                setRoleName(tempRN)
                setIsExternal(Boolean(tempIE))
                setPermissions(tempP)
                setPassLine(tempL)
                setIsFirst(tempIF)
                ctx.setIsLoad(false)
                return
            }
        }
        getRefresh(sessionLine)
    }

    // eslint-disable-next-line
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, operation, roleName, isExternal, permissions, passLine])

    const getRefresh = (line) => {
        const lineRole = line ? line : passLine
        const roleIdentifier = lineRole?.RoleName ?? lineRole?.Name
        let tempArray = buildDefaultPermissions()
        if (operation === 'Create') {
            setRoleName('')
            setIsExternal(false)
            setPermissions(tempArray)
            ctx.setIsLoad(false)
        } else {
            if (lineRole === 'Error' || !roleIdentifier) {
                ctx.setIsLoad(false)
                handleTabClose(id)
                ctx.toastMessages('error', '', t("SelectedLine"))
                return
            }
            bufferRoles.getId(roleIdentifier).then((response) => {
                if (isRequestError(response)) {
                    ctx.setIsLoad(false)
                    ctx.toastMessages('error', '', response.message)
                    handleTabClose(id)
                    return
                }

                const normalizedRole = resolveRoleResponse(response, lineRole)
                setRoleName(normalizedRole.roleName)
                setIsExternal(normalizedRole.isExternal)
                tempArray = mapDetailsToPermissions(normalizedRole.details)
                setPermissions(tempArray)
                ctx.setIsLoad(false)
                ctx.toastMessages('success', '', t("LabelRoleSucc"))
            })
        }
    }

    const checkboxBody = (e, items) => {
        if (items === 'SelectAll') {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: '20px' }}>
                    <M_CheckBox
                        disableRipple={true}
                        checked={e[items] || false}
                        disabled={operation === 'View'}
                        onChange={(elem) => selectAll(e.Name, elem.target.checked)}
                    />
                </div>
            )
        }
        if (RolesDisableList.includes(`${e.Value}${items}`) || operation === 'View') {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: '20px' }}>
                    <M_CheckBox
                        disabled={true}
                        checked={e[items] || false}
                        onChange={(elem) => changeTable(e.Name, items, elem.target.checked)}
                    />
                </div>
            )
        } else {
            return (
                <div style={{ display: 'flex', justifyContent: 'center', width: '100%', height: '20px' }}>
                    <M_CheckBox
                        checked={e[items] || false}
                        onChange={(elem) => changeTable(e.Name, items, elem.target.checked)}
                    />
                </div>
            )
        }
    }

    const selectAll = (data, value) => {
        const tempArray = permissions.map(obj => {
            if (obj.Name === data) {
                const tempObj = { ...obj }
                columns.forEach(element => {
                    if (RolesDisableList.includes(obj.Value + element)) {
                        return
                    }
                    tempObj[element] = value
                });
                return tempObj
            }
            return obj
        })
        setPermissions(tempArray)
    }

    const changeTable = (name, field, value) => {
        setPermissions(permissions.map(obj => {
            if (obj.Name == name) {
                return {
                    ...obj,
                    [field]: value
                }
            } else return obj
        }))
    }

    const onSave = async () => {
        ctx.setIsLoad(true)
        const parsedRoleName = roleName?.trim()
        const selectedDetails = getSelectedDetails()
        const permissionsArray = selectedDetails.map(value => ({
            "Key": "PERMISSION",
            "Value": value
        }))
        if (!parsedRoleName) {
            ctx.toastMessages('error', '', t('RequiredField'))
            ctx.setIsLoad(false)
            return
        }

        const roleId = passLine?.Id
        const routeCreate = `/${parsedRoleName}?external=${isExternal}`
        const routeUpdate = `/${parsedRoleName}?id=${roleId ?? ''}&external=${isExternal}`
        let response

        if (operation === 'Create' || operation === 'Copy') {
            response = await bufferRoles.postPath(routeCreate, permissionsArray)
        } else {
            if (!roleId) {
                ctx.setIsLoad(false)
                ctx.toastMessages('error', '', t("SelectedLine"))
                return
            }

            response = await bufferRoles.putQuery(routeUpdate, permissionsArray)
        }

        if (isRequestError(response)) {
            ctx.setIsLoad(false)
            ctx.toastMessages('error', '', response.message)
            return
        }

        ctx.setIsLoad(false)
        ctx.toastMessages('success', '', t('Success'))
        setTimeout(() => {
            handleTabClose(id)
        }, 1000)
    }

    return (
        <div className='firstDivContainer'>
            <M_Header
                element={<>
                    <M_Button
                        tooltip={t("RefreshTable")}
                        icon={<i className="pi pi-refresh headerIcon"></i>}
                        label={<b>{t("RefreshTable")}</b>}
                        onClick={() => getRefresh()}
                    />
                    <M_Button
                        tooltip={t("Save")}
                        icon={<i className="pi pi-save headerIcon"></i>}
                        label={<b>{t("Save")}</b>}
                        onClick={() => onSave()}
                    />
                </>}
            />
            <div className='tableDiv'>
                <div >
                    <M_InputTextField disabled={operation === 'View' ? true : false} label={t("LabelRoleName")} value={roleName} onChange={(e) => setRoleName(e.target.value)} />
                    <M_CheckBox
                        label={t("IsExternal")}
                        checked={isExternal}
                        onChange={(e) => setIsExternal(e.target.checked)}
                        disabled={operation === 'View' ? true : false}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '15px' }}>
                <DataTable className={'datatable'} value={permissions} size='small' paginator rows={15} tableStyle={{ maxWidth: '80%' }}>
                    <Column field='Name' header='' style={{ minWidth: '250px', width: '250px', maxWidth: '250px', fontWeight: 'bold' }} body={(e) => t(e.Name)} filterMatchMode="contains" />
                    {columns.map((items, index) => (
                        <Column key={index} field={items} header={t(items)} body={(e) => checkboxBody(e, items)}>items</Column>
                    ))}
                </DataTable>
            </div>
        </div >
    )
}
